module.exports = __webpack_public_path__ + "static/media/deserter.1651f740.png";